import type { PayloadAction } from "@reduxjs/toolkit";

import type { IActiveCategory } from "./models";

export const UPDATE = "activeCategory/update";
export function updateActiveCategory(
  payload: IActiveCategory,
): PayloadAction<IActiveCategory> {
  return {
    type: UPDATE,
    payload,
  };
}

export const CLEAR = "activeCategory/clear";
export function clearActiveCategory(): PayloadAction<null> {
  return {
    type: CLEAR,
    payload: null,
  };
}
